import { EventEmitter } from '@angular/core';

import { BulkItemBase } from '@recruitee/bulk-actions';

import { AnyGroup, GroupsState } from './data/groups.types';
import { ViewRecordData, ViewStoreMeta } from './data/layout-types';
import { ViewRecord } from './data/record-types';
import { Swimlane, SwimlanesState } from './data/swimlanes-types';

export interface SwimlanesRecordsData {
  swimlane: Swimlane | null;
  groups: Array<ViewRecordData<ViewRecord>>;
}

export interface SwimlanesData {
  swimlaneGroupingId: string | null;
  swimlanesState: SwimlanesState | null;
  swimlanesMeta: ViewStoreMeta | null;
  groupingId: string | null;
  groupsState: GroupsState | null;
  groupsMeta: ViewStoreMeta | null;
  data: SwimlanesRecordsData[];
}

/**
 * Wrap record to make it uniq between groups
 */
export const isBulkItemWrapped = Symbol('wrapped');
export interface BulkItemWrapped {
  id: string;
  record: BulkItemBase;
  [isBulkItemWrapped]: true;
}

export interface LayoutBoardGroupHeader {
  group: AnyGroup;
  selectionInGroup: 'indeterminate' | 'all' | null;
  select: EventEmitter<AnyGroup>;
}
